"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "gost_7034",
    description: "GOST R 7.0.34-2014 transliteration schema",
    url: "http://localhost:3000/iuliia/gost-7034/",
    comments: [
        "This schema defines alternatives for many letters, but does not specify when to use which:",
        "  е → e  (ye)",
        "  ё → yo (jo)",
        "  й → j  (i,y)",
        "  х → x  (kh)",
        "  ц → c  (tz,cz)",
        "  ъ → '' (empty)",
        "  ь → '  (empty)",
        "  ю → yu (ju)",
        "  я → ya (ja)",
        "`iuliia` uses the first of suggested translations for each such letter.",
    ],
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "j",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "x",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "shh",
        ъ: "''",
        ы: "y",
        ь: "'",
        э: "e",
        ю: "yu",
        я: "ya",
    },
    prev_mapping: null,
    next_mapping: null,
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Yuliya, s''esh' eshhyo etix myagkix francuzskix bulok iz Joshkar-Oly, da vypej altajskogo chayu",
        ],
    ],
};
